<template>
    <iframe :src="`//wx.rennengda.com/quest/?questcode=${questCode}&system=consultStudent`"
        style="width: 100%; height: 90vh; border: 0;" id="myIframe" :key="iframeKey"></iframe>
</template>

<script>
import { parseQuestNameByCode } from '@/assets/js/questIntro'
import { mapState } from 'vuex'
import HttpRequest from '@/utils/request'
import { getSessionData, removeSessionData, setSessionData } from '@/utils/cache'
export default {
    data() {
        return {
            iframeKey: 0,
            questCode: null,
            handleMessage: null,
            checkupId: null,
            type: null,
            questId: null,
            time: null,
        }
    },
    created() {
        this.questCode = this.$route.query.questCode;
        this.checkupId = this.$route.query.checkupId
        this.type = this.$route.query.type
        this.questId = this.$route.query.questId
        this.time = this.$route.query.time
        document.title = parseQuestNameByCode(this.questCode);
    },
    mounted() {
        this.handleMessage = (event) => {
            let eventData;
            try {
                eventData = JSON.parse(event.data);
            } catch (error) {
                return;
            }
            if (eventData.event === "buttonClicked") {
                console.log(eventData.answer, eventData.index, '接收');
                this.submitAnswer(eventData.answer, eventData.index);
            }
        };

        window.addEventListener("message", this.handleMessage);
    },
    computed: {
        ...mapState({
            student: (state) => state.user.student
        })
    },
    beforeDestroy() {
        window.removeEventListener("message", this.handleMessage);
    },
    methods: {
        submitAnswer(answer, index) {
            let url = '/constub/saveAnswer'
            let data = {
                token: this.student.token,
                answer: answer,
                questCode: this.questCode,
                checkupId: this.checkupId,
                type: this.type,
                questId: this.questId
            };
            //如果是九型人格则传递参数增加一个随机下标
            if (this.questCode === 'ennea') {
                data.enneaIndex = index
            }
            HttpRequest.requestFormPost(url, data).then((res) => {
                if (res && res.result.success) {
                    let checkup = res.data
                    this.iframeKey += 1;
                    //跳转
                    this.changLink(checkup)
                } else {
                    this.iframeKey += 1;
                    this.$alert(res.result.message, { confirmButtonText: '确定', showClose: false })
                }
            })
        },
        changLink(checkup) {
            let data = {
                questId: checkup.questId,
                questCode: checkup.questCode,
                time: checkup.updateTime
            }
            this.$router.push({
                path: ((getSessionData("partner") == null || getSessionData("partner") == undefined)
                    ? 'simpleQuestFinish' : 'questFinish'), query: { data: JSON.stringify(data) }
            })
        },
    }
}
</script>

<style></style>